import { render, staticRenderFns } from "./InviteJoinResult.vue?vue&type=template&id=5eb2ae56&scoped=true"
import script from "./InviteJoinResult.vue?vue&type=script&lang=js"
export * from "./InviteJoinResult.vue?vue&type=script&lang=js"
import style0 from "./InviteJoinResult.vue?vue&type=style&index=0&id=5eb2ae56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb2ae56",
  null
  
)

export default component.exports